module.exports = __webpack_public_path__ + "static/parade-2020-house06-aea080af5ac1fbc5d68d713edfb64b5f.jpg";